// The icon before a route chip's word, so the kind reads at a glance (Josh, 10-06) — the headset's set
// (clients/visionos/Harness/Core/LinkChoice.swift `symbol`: dot.radiowaves.left.and.right · wifi.router · globe ·
// arrow.triangle.2.circlepath) as inline SVG, stroked in the chip's own colour. One table; Home's chip and popover
// and the Connection sheet's lines (core/live.js) all draw from it. Static markup, nothing of a Mac's in it.
// A browser reaches a Mac over WebRTC only, so it shows `direct` and `relay`; `radio` and `lan` are here for the
// headset's screens the WebXR app mirrors.

const PATHS = {
  radio: '<circle cx="12" cy="12" r="2"/><path d="M16.2 7.8a6 6 0 0 1 0 8.4M7.8 16.2a6 6 0 0 1 0-8.4M19 5a10 10 0 0 1 0 14M5 19A10 10 0 0 1 5 5"/>',
  lan: '<path d="M12 20h.01M8.5 16.4a5 5 0 0 1 7 0M5 12.9a9 9 0 0 1 14 0M2 9a13 13 0 0 1 20 0"/>',
  direct: '<circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>',
  relay: '<path d="M21 12a9 9 0 0 1-15.5 6.2L3 16M3 21v-5h5M3 12a9 9 0 0 1 15.5-6.2L21 8M21 3v5h-5"/>',
}

export const ROUTE_KINDS = Object.keys(PATHS)

/// `kind`: 'radio' | 'lan' | 'direct' | 'relay' → the <svg> string; '' for a kind not in the table.
export function routeIcon(kind) {
  const d = PATHS[kind]
  if (!d) return ''
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`
}
